import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';

export function useProjectsApi(setAlert, selectedProjects) {
    const parseEntities = txt => new DOMParser().parseFromString(txt, 'text/html').body.innerText;
    const [projects, setProjects] = useState([]);
    let controller = false;

    useEffect(() => {
        if (selectedProjects) {
            let params = new URLSearchParams(selectedProjects.map(s=>['include[]',s]));
            getProjects(params);
        } else {
            getProjects();
        }
    }, []);

    const searchProjects = (form) => {
        let formData = new FormData(form);

        for (let [name, value] of Array.from(formData.entries())) {
            if (value === '') formData.delete(name);
        }

        getProjects(new URLSearchParams(formData));
    }

    const modifyOutput = (projectData) => {
        let data = {}

        if (projectData) {
            data.title = parseEntities(projectData.title.rendered);
            data.slug = projectData.slug;
            data.thumbnail = projectData.fimg_url;

            data.location = {
                latitude: projectData.acf.location.lat,
                longitude: projectData.acf.location.lng
            };

            data.taxonomies = {
                'sector': projectData.sector,
                'project-type': projectData['project-type'],
                'location': projectData.location,
            };

            data.link = projectData.link;
        }

        return data;
    }

    const getProjects = (dataParamsStr) => {
        if (controller) {
          controller.abort({message: 'Fetching interrupted by user.'});
        }

        if (dataParamsStr) {
          dataParamsStr.append('per_page', 100);
        }

        controller = new AbortController();

        fetch("/wp-json/schnapps/v1/projects-markers?" + (dataParamsStr ? ("&" + dataParamsStr) : ''), { signal: controller.signal })
        .then(response => {
            if (!response.ok) {
                // make the promise be rejected if we didn't get a 2xx response
                const err = new Error();
                err.response = response;
                throw err;
            } else {
                 return response.json();
            }
        })
        .then(data => {
            this.controller = null;

            if (data.length) {
                let projects = data.filter(project => project.status == 'publish');
                let projectsData = projects;
                setProjects(projectsData);
                setAlert("Showing our " + projectsData.length + " projects");
            }
            else {
                setProjects([]);
                setAlert("Sorry, we found no projects near you. Please contact us if you'd like to purchase!", null, "error");
            }
        })
        .catch(error => {
            // location not found
            setProjects([]);
            setAlert("Sorry, we could not find that location. Please check your town/postcode.", null, "error");
        });
    }

    return [projects, searchProjects];

}
